import { useState, useLayoutEffect } from 'react'

export const useShowMore = (ref, maxLines) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isTruncated, setIsTruncated] = useState(false)

  const toggleReadMore = (e) => {
    e.preventDefault()
    setIsExpanded(!isExpanded)
  }

  useLayoutEffect(() => {
    const element = ref.current
    if (element) {
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight)
      const maxHeight = maxLines * lineHeight
      const scrollHeight = element.scrollHeight

      if (Math.abs(scrollHeight - maxHeight) > lineHeight) {
        setIsTruncated(true)
      }
    }
  }, [maxLines, isExpanded, ref.current])

  return {
    isTruncated,
    isExpanded,
    toggleReadMore,
  }
}
